import { CONTAINER_HANDLING_UNIT } from "@RequestFormV2/defaults/packingListDefaults";
import type { IndexedPackingListRow, PackingListRow } from "@RequestFormV2/sections/PackingList/types";

export function isContainerRow(row: PackingListRow | undefined) {
  return row?.handling_unit === CONTAINER_HANDLING_UNIT;
}

export function isHandlingUnitRow(row: PackingListRow | undefined) {
  return !isContainerRow(row);
}

export function splitPackingListRows(
  packingList: PackingListRow[] | undefined,
  fields?: { id: string }[],
): {
  containerRows: IndexedPackingListRow[];
  handlingUnitRows: IndexedPackingListRow[];
} {
  const rows = packingList ?? [];
  const fieldEntries = fields ?? rows.map((_, index) => ({ id: `packing-list-row-${index}` }));

  return fieldEntries.reduce<{
    containerRows: IndexedPackingListRow[];
    handlingUnitRows: IndexedPackingListRow[];
  }>((acc, field, index) => {
    const row = rows[index];
    if (!row) return acc;

    const indexed = { index, fieldId: field.id, row };
    if (isContainerRow(row)) {
      acc.containerRows.push(indexed);
    } else {
      acc.handlingUnitRows.push(indexed);
    }
    return acc;
  }, { containerRows: [], handlingUnitRows: [] });
}
